package fr.frux.shared.data.local

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provider
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.common.prefs.AppPreferences
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.localDatabaseSupported

/**
 * Fourniture de la copie locale de la pyramide (#622). Le web n'a pas de base mais garde la
 * pyramide en localStorage, d'ou la variante preferences plutot que le repli No-Op.
 */
@ContributesTo(AppScope::class)
interface ClusterPyramidLocalDataSourceModule {
    companion object {
        @Provides
        @SingleIn(AppScope::class)
        fun provideClusterPyramidLocalDataSource(
            database: Provider<FruxDatabase>,
            preferences: AppPreferences,
        ): ClusterPyramidLocalDataSource =
            if (localDatabaseSupported) {
                SqlDelightClusterPyramidLocalDataSource(database())
            } else {
                PreferencesClusterPyramidLocalDataSource(preferences)
            }
    }
}
